import '../style.css';
import { mountStealthGame } from './game';

mountStealthGame();
